<div class="line" data-testid="cart-line" [class.read-only]="readOnly">
  <div class="item-box">
    <h5 class="capital" [class.struck-through]="line.pickedUp">
      @if (readOnly && line.quantity > 1) {
        <span class="qty-prefix">x{{ line.quantity }}</span>
      }
      <span translate [translateParams]="{name: line.itemName | titlecase}">CART.ITEM_LINE</span>
    </h5>
    @if (line.sectionLabel) {
      <small class="capital section-label">{{ line.sectionLabel }}</small>
    }
    @for (modifier of line.modifiers; track modifier.name) {
      <p class="capital">
        * @if (modifier.quantity > 1) {
          <span class="qty-prefix">x{{ modifier.quantity }}</span>
        } {{ modifier.name | titlecase }}
        @if (modifier.price > 0) {
          <b>
            (+ {{ modifier.price | currencySpace }})
          </b>
        }
      </p>
    }
    @if (line.comment) {
      <small class="capital item-note"><b>{{ 'CART.NOTE_LABEL' | translate }}:</b> {{ line.comment }}</small>
    }
    @if (!readOnly) {
      <div class="edit-action" data-testid="cart-line-edit" (click)="editClick.emit()">
        <img class="icon-md" [src]="'edit-modifier.svg' | themeSource" alt="edit">
        <b translate class="capital">ACTIONS.EDIT</b>
      </div>
    }
  </div>

  <div class="item-box">
    @if (!readOnly) {
      <div class="stepper">
        <button type="button" data-testid="cart-line-decrease" (click)="decrease.emit()">
          <mat-icon>remove</mat-icon>
        </button>
        <span data-testid="cart-line-quantity">{{ line.quantity }}</span>
        <button type="button" data-testid="cart-line-increase" (click)="increase.emit()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    }
    <span data-testid="cart-line-total">{{ line.total | currencySpace }}</span>
  </div>
</div>
